import cn from 'classnames'
import React, { useRef } from 'react'
import { useReactToPrint } from 'react-to-print'

import Button from './common/Button'
import { format } from '../utils/number'
import { getDateTime } from '../utils/date'
import { getPaymentMethods, getStatusTypes } from '../utils/types'
import { downloadDocxReceipt } from './generateDocx'
import { ArchiveCustomCheckPrint } from './customs/archive-check-print'

export default function ArchiveItem({ item, index }) {
    const resultArchive = item.orderProduct.reduce((totalCost, currentValue) => {
        const count = parseInt(currentValue?.count, 10) || 0
        const returnedAmount = parseInt(currentValue?.returnedAmount, 10) || 0
        const actualCount = count - returnedAmount
        const price = parseInt(currentValue?.price, 10) || 0

        return totalCost + actualCount * price
    }, 0)

    const componentRef = useRef()

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    })

    console.log(item, 'nimabdan')

    return (
        <>
            <td>{index + 1}</td>
            <td className={cn(item?.status === 'successfully' ? 'has-text-black' : 'has-text-danger')}>{getStatusTypes(item?.status)}</td>
            <td>{item?.codeContent}</td>
            <td>{item.client.name}</td>
            <td className="">{item.client.phoneNumber}</td>
            <td className="">
                {format(resultArchive)} {item?.currency === 'usd' ? 'USD' : 'Сум'}
            </td>
            <td>
                <span style={{
                    backgroundColor: (item.sumComing - item.sumBuy) >= 0 ? '#48c774' : '#f14668',
                    color: '#fff',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '0.85rem',
                    fontWeight: '600',
                    whiteSpace: 'nowrap'
                }}>
                    {format(item.sumComing - item.sumBuy)} Сум
                </span>
            </td>
            <td className="">{getDateTime(item.createdAt)}</td>
            <td>{item.paymentMethod ? getPaymentMethods(item.paymentMethod) : ''}</td>
            <td>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                    <Button
                        onClick={(e) => {
                            e.stopPropagation()
                            handlePrint()
                        }}
                        className="button is-link mr-2 is-small is-outlined"
                        icon="print"
                    />
                    <div style={{ display: 'none' }}>
                        <ArchiveCustomCheckPrint paidAmount={item.sumComing} lend={item.amount - item.sumComing} result={item.amount} item={item} ref={componentRef} />
                    </div>

                    <Button
                        onClick={(e) => {
                            e.stopPropagation()
                            downloadDocxReceipt(item, resultArchive, item.amount - item.sumComing)
                        }}
                        className="button is-success mr-2 is-small is-outlined"
                        icon="download"
                        text="DOCX"
                    />
                </div>
            </td>
        </>
    )
}
